import { Link } from 'react-router-dom';
import { getLatestArticles, getHotArticles, Article } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = getLatestArticles(8);
  const hotArticles = getHotArticles().slice(0, 4);

  const ArticleCard = ({ article, variant = 'default' }: { article: Article; variant?: 'default' | 'hot' }) => (
    <Link
      to={`/article/${article.id}`}
      className="group cursor-pointer"
    >
      <div className="relative rounded-xl overflow-hidden aspect-[16/10] mb-3">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {article.isHot && (
          <span className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-primary-500 text-white text-xs font-medium">
            热门
          </span>
        )}
      </div>
      <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors mb-2">
        {article.title}
      </h3>
      <p className="text-xs text-foreground-500 line-clamp-2 mb-2">{article.excerpt}</p>
      <div className="flex items-center gap-2 text-xs text-foreground-400">
        <span>{article.publishDate}</span>
        <span>·</span>
        <span>{(article.readCount / 10000).toFixed(1)}万阅读</span>
      </div>
    </Link>
  );

  return (
    <section className="bg-background-100/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
              <h2 className="font-heading text-xl font-bold text-foreground-900">最新爆料</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
            <div className="mt-8 text-center">
              <Link
                to="/category/yule-bagua"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 border border-background-300/60 text-foreground-700 hover:border-primary-300 hover:text-primary-500 transition-all duration-200 text-sm font-medium whitespace-nowrap"
              >
                加载更多 <i className="ri-arrow-down-line"></i>
              </Link>
            </div>
          </div>

          <aside className="lg:col-span-1">
            <div className="sticky top-24">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
                <h2 className="font-heading text-xl font-bold text-foreground-900">热门爆料</h2>
              </div>
              <div className="space-y-4">
                {hotArticles.map((article, index) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="flex gap-3 group cursor-pointer"
                  >
                    <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 font-heading font-bold text-sm">
                      {String(index + 1).padStart(2, '0')}
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-sm font-medium text-foreground-800 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                        {article.title}
                      </h3>
                      <div className="flex items-center gap-2 mt-1 text-xs text-foreground-400">
                        <span>{(article.readCount / 10000).toFixed(1)}万阅读</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>

              <div className="mt-8 p-5 rounded-xl bg-accent-50/50 border border-accent-200/50">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-fire-line text-lg text-accent-500"></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900">24小时热榜</h3>
                </div>
                <div className="space-y-2">
                  {hotArticles.slice(0, 5).map((article, index) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.id}`}
                      className="flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      <span className="text-accent-500 font-bold text-xs min-w-[18px]">{index + 1}.</span>
                      <span className="line-clamp-1">{article.title}</span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}